import { UUID } from '@/types/Id'

interface ExcerptsQueryKeyArgs {
  orgId: UUID | ''
  pursuitId?: UUID | ''
}

interface ExcerptQueryKeyArgs {
  excerptId: UUID | ''
}

interface PursuitExcerptsQueryKeyArgs {
  pursuitId: UUID | ''
}

const organizationExcerptsFn = (keyArgs: ExcerptsQueryKeyArgs) =>
  ['excerpts', keyArgs.orgId] as const

const pursuitExcerptsFn = (keyArgs: PursuitExcerptsQueryKeyArgs) =>
  ['pursuit_excerpts', keyArgs.pursuitId] as const

export const excerptsQueryKeys = {
  all: () => ['excerpts'] as const,
  organization: organizationExcerptsFn,
  count: (keyArgs: ExcerptsQueryKeyArgs) =>
    ['excerpts', keyArgs.orgId, 'count'] as const,
  pursuit: pursuitExcerptsFn,
  pursuitOrOrganization: (keyArgs: ExcerptsQueryKeyArgs) =>
    keyArgs.pursuitId
      ? pursuitExcerptsFn({ pursuitId: keyArgs.pursuitId })
      : organizationExcerptsFn({ orgId: keyArgs.orgId }),
}

export const excerptQueryKeys = {
  excerpt: (keyArgs: ExcerptQueryKeyArgs) =>
    ['excerpt', keyArgs.excerptId] as const,
}
